export default __webpack_public_path__ + "static/media/Tooltip.6b9bb9ce.svg";